import { useSelector } from 'react-redux';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'antd';

import Colors from '../../constants/Colors';
import { safeExtractFromObject } from '../../helpers/helpers';
import { ReactComponent as WorkflowMarketPlaceIcon } from '../../assets/icons/workflow-marketplace.svg';

export default function WorkflowMarketplaceButton({ openWorkflowMarketplace, }) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const workflows = useSelector((state) => state.workflowMarketplace.workflows);
  const hasRedesign = settings?.uxRedesignPt1;

  const hasNewWorkflows = useMemo(() => (
    workflows.some((workflow) => workflow.recentlyAdded)
  ), [workflows]);

  const badgeSize = hasNewWorkflows ? 8 : 0;
  return (
    <div
      className={hasRedesign ? 'header-container-redesign workflow-marketplace-button' : 'header-container'}
      onClick={openWorkflowMarketplace}
    >
      <Badge dot color={Colors.ORANGE_400} style={{ width: badgeSize, height: badgeSize }}>
        <WorkflowMarketPlaceIcon />
      </Badge>
    </div>
  );
}

WorkflowMarketplaceButton.propTypes = {
  openWorkflowMarketplace: PropTypes.func.isRequired,
};